import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function KKondhwatomumbaicab() {



const cardData = {
  keyword: " Kondhwa to Mumbai Cabs  ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Kondhwa to Mumbai cab services, ensuring a hassle-free and smooth journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Kondhwa to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kondhwa to Mumbai cab travel.",

topPlaces: [
  {
    title: "Flora Fountain",
    description: "Flora Fountain is a magnificent Victorian monument located in the heart of South Mumbai and surrounded by heritage buildings and bustling business districts. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this iconic landmark while visiting nearby shopping streets, cafés, and colonial-era architecture. It is a great destination for history enthusiasts, photographers, and anyone interested in Mumbai's rich heritage."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is one of Mumbai's most scenic waterfront promenades, offering breathtaking views of the Arabian Sea and the city's skyline. Visitors choosing an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing by the coastline, taking evening walks, and witnessing the famous sunset that makes Marine Drive one of Mumbai's top attractions."
  },
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the center of India's entertainment industry and home to numerous Bollywood movie and television sets. Renting an Innova Crysta in Pune makes the journey convenient for families and groups interested in guided studio tours, film sets, and behind-the-scenes experiences of India's vibrant film industry."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most vibrant shopping destinations, offering fashion accessories, handicrafts, antiques, cafés, and street food. Travelers hiring an Innova Crysta on rent in Pune can comfortably explore this lively market while enjoying local shopping and discovering the charm of South Mumbai."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a vast green oasis within Mumbai, famous for its wildlife, cycling trails, boating, and lush forests. Booking an Innova Crysta on rent in Pune ensures a comfortable drive to this natural attraction, making it an excellent destination for families, adventure lovers, and nature enthusiasts."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill are beautifully landscaped terraced gardens offering panoramic views of the Arabian Sea and Marine Drive. Travelers choosing an Innova Crysta on rent in Pune can relax amidst well-maintained greenery, unique topiary displays, and peaceful surroundings while enjoying one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most popular coastal attractions, known for its lively atmosphere, delicious street food, and spectacular sunsets. Visitors renting an Innova Crysta in Pune can comfortably travel to Mumbai and spend quality time enjoying beach walks, local snacks, and family-friendly entertainment."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a remarkable meditation monument featuring one of the world's largest stone domes. Travelers booking an Innova Crysta on rent in Pune can enjoy a scenic drive to this peaceful destination near Gorai and experience meditation, spiritual learning, and impressive architecture surrounded by serene landscapes."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque urban lake surrounded by gardens, restaurants, and modern city landmarks. Hiring an Innova Crysta on rent in Pune provides a smooth journey for families and groups looking to enjoy lakeside views, peaceful walks, boating, and quality leisure time in one of Mumbai's most attractive neighborhoods."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most iconic historical monument overlooking the Arabian Sea. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this famous landmark, admire its magnificent architecture, enjoy ferry rides to nearby attractions, and capture unforgettable photographs at one of India's most recognized tourist destinations."
  }
],



services: [
{
name: "Kondhwa to Mumbai Cab Fare",
description: "Kondhwa to Mumbai cab fare service provides transparent pricing for passengers traveling between Kondhwa in Pune and Mumbai city. Travelers can choose from sedan, Ertiga, or Innova vehicles depending on comfort and budget. Professional drivers ensure safe expressway travel via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, and residential societies in Kondhwa."
},
{
name: "Kondhwa to Mumbai Airport Cab",
description: "Kondhwa to Mumbai Airport cab service offers reliable airport transportation from Kondhwa to Chhatrapati Shivaji Maharaj International Airport. Vehicles provide comfortable seating and luggage space suitable for airport travel. Professional drivers ensure punctual pickup and safe highway journeys."
},
{
name: "Kondhwa to Navi Mumbai Cab",
description: "Kondhwa to Navi Mumbai cab service provides dependable transportation between Kondhwa in Pune and Navi Mumbai city. Comfortable vehicles with experienced drivers ensure safe long-distance travel for business trips, tourism visits, and family journeys."
},
{
name: "Cab Service in Kondhwa",
description: "Cab service in Kondhwa offers reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe and convenient travel across Kondhwa and nearby Pune areas."
},
{
name: "NIBM Road to Mumbai Cab",
description: "NIBM Road to Mumbai cab service provides dependable transportation between Pune’s NIBM Road area and Mumbai city. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "NIBM Road to Mumbai Airport Cab",
description: "NIBM Road to Mumbai Airport cab service offers reliable airport transfers from NIBM Road in Pune to Mumbai Airport terminals. Comfortable vehicles and professional drivers ensure smooth highway travel."
},
{
name: "Cab Service in NIBM Road",
description: "Cab service in NIBM Road provides convenient transportation for local travel, airport transfers, and outstation trips. Vehicles are well maintained and driven by experienced drivers ensuring safe journeys."
},
{
name: "Cab Service Undri Road",
description: "Cab service Undri Road offers dependable taxi transportation for passengers traveling from Undri to Pune city or nearby destinations. Comfortable vehicles and professional drivers ensure safe travel."
},
{
name: "Taxi Service in Undri Pune",
description: "Taxi service in Undri Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel experiences."
},
{
name: "Taxi Service Katraj",
description: "Taxi service in Katraj provides convenient transportation for passengers traveling within Pune or planning intercity journeys. Vehicles are comfortable and suitable for daily commuting and highway travel."
},
{
name: "Katraj to Mumbai Cab Service",
description: "Katraj to Mumbai cab service offers reliable transportation between Pune’s Katraj area and Mumbai city. Vehicles are comfortable and suitable for long-distance expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Katraj to Mumbai Airport Cab Service",
description: "Katraj to Mumbai Airport cab service provides dependable airport transportation between Katraj in Pune and Mumbai Airport terminals. Vehicles offer comfortable seating and luggage space suitable for airport journeys."
},
{
name: "Kondana to Bandra Cab Service",
description: "Kondana to Bandra cab service offers reliable transportation between Pune region and Bandra in Mumbai. Comfortable vehicles and professional drivers ensure safe expressway travel."
},
{
name: "Kondana to Dadar Cab Service",
description: "Kondana to Dadar cab service provides dependable transportation between Pune region and Dadar in Mumbai. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Kondana to Mumbai Airport Cabs",
description: "Kondana to Mumbai Airport cab service offers convenient airport transportation from Pune region to Mumbai Airport. Vehicles provide comfortable seating and luggage capacity suitable for airport transfers."
},
{
name: "Cab Service in Kondhwa Pune",
description: "Cab service in Kondhwa Pune provides reliable transportation for passengers traveling within Pune city and nearby destinations. Vehicles are comfortable and suitable for local rides and long-distance journeys."
},
{
name: "Velocity Cabs Pune",
description: "Velocity Cabs Pune provides dependable transportation services for city travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe and convenient rides."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Vehicles are comfortable and suitable for daily commuting and highway travel."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for passengers traveling from Pune city to Mumbai Airport terminals. Vehicles ensure comfortable seating and safe expressway travel."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers reliable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Kondhwa to Outstation Cab Service",
description: "Kondhwa to outstation cab service offers convenient transportation from Kondhwa to nearby cities and tourist destinations. Comfortable vehicles and professional drivers ensure safe highway travel."
},
{
name: "Kondhwa to Mumbai Cab",
description: "Kondhwa to Mumbai cab service provides dependable transportation between Kondhwa in Pune and Mumbai city. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Kondhwa to Mumbai Taxi",
description: "Kondhwa to Mumbai taxi service offers reliable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for long-distance highway travel."
},
{
name: "Kondhwa to Mumbai Cab Service",
description: "Kondhwa to Mumbai cab service offers convenient transportation between Kondhwa in Pune and Mumbai city. Professional drivers ensure safe expressway travel with comfortable vehicles."
},
{
name: "Kondhwa to Mumbai Taxi Service",
description: "Kondhwa to Mumbai taxi service provides dependable transportation between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe journeys via the expressway."
},
{
name: "Kondhwa to Mumbai Cab Booking",
description: "Kondhwa to Mumbai cab booking service allows passengers to easily reserve taxis for intercity travel. Flexible booking options and professional drivers ensure convenient and safe travel experiences."
}
],

tableData: [
["Kondhwa to Mumbai Cab Fare","Kondhwa to Mumbai Airport Cab"],
["Kondhwa to Navi Mumbai Cab","Cab Service in Kondhwa"],
["NIBM Road to Mumbai Cab","NIBM Road to Mumbai Airport Cab"],
["Cab Service in NIBM Road","Cab Service Undri Road"],
["Taxi Service in Undri Pune","Taxi Service Katraj"],
["Katraj to Mumbai Cab Service","Katraj to Mumbai Airport Cab Service"],
["Kondana to Bandra Cab Service","Kondana to Dadar Cab Service"],
["Kondana to Mumbai Airport Cabs","Cab Service in Kondhwa Pune"],
["Velocity Cabs Pune","Cab Service in Pune"],
["Pune to Mumbai Airport Cab","Pune Mumbai Cab"],
["Kondhwa to Outstation Cab Service","Kondhwa to Mumbai Cab"],
["Kondhwa to Mumbai Taxi","Kondhwa to Mumbai Cab Service"],
["Kondhwa to Mumbai Taxi Service","Kondhwa to Mumbai Cab Booking"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Kondhwa to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Kondhwa to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Kondhwa to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, business travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Kondhwa to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kondhwa",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and residential societies across Kondhwa and nearby areas like NIBM Road, Salunkhe Vihar, Wanowrie, and Undri."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Kondhwa to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Kondhwa to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Kondhwa to Mumbai with professional drivers and comfortable vehicles." },
  { question: "How far is Kondhwa from Mumbai?", answer: "The road distance between Kondhwa and Mumbai is around 150–154 km and the journey usually takes about 3 to 4 hours depending on traffic conditions." },
  { question: "Is Kondhwa to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Kondhwa to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Kondhwa to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Kondhwa and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Kondhwa." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Kondhwa to Mumbai cab services online or through phone booking." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Jadhav",
    feedback:
      "The Kondhwa to Mumbai journey was handled very smoothly. The cab was comfortable, arrived on time, and the entire ride felt relaxed and well-managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "From Kondhwa to Mumbai, the travel experience was really good. The vehicle was clean, the drive was steady, and everything was organized in a professional way.",
    rating: 5
  }
];






































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kondhwa to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Kondhwa to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis for airport transfers, Navi Mumbai, NIBM Road, Undri Road, Katraj, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Kondhwa and nearby areas to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Kondhwa to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Kondhwa to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis for Navi Mumbai, NIBM Road, Undri Road, Katraj & Mumbai airport. Safe and reliable cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default KKondhwatomumbaicab;